// extracted by mini-css-extract-plugin
export var createAccount = "create-account_zryBCPYlJR9GQ84ptagq";
export var createAccountHeader = "create-account__header_lp1YDoxcDbX1PIi04Yj8";
export var createAccountTitle = "create-account__title_aahkg2ReBUTL3IjQAUxF";